import { Exclude, Expose, Type } from 'class-transformer';
import type { EOrientation } from '../../../core/EOrientation';
import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';
import { DrawInsideBottleShelf } from './DrawInsideBottleShelf';
import { DrawInsideDoorRack } from './DrawInsideDoorRack';
import { DrawInsideHookBar } from './DrawInsideHookBar';
import { DrawInsideLiftingColumn } from './DrawInsideLiftingColumn';
import { DrawInsidePlateHolder } from './DrawInsidePlateHolder';
import { DrawInsideShelf } from './DrawInsideShelf';
import { DrawInsideShelfSystem } from './DrawInsideShelfSystem';
import { DrawInsideTablet } from './DrawInsideTablet';
import { DrawInsideTrashCan } from './DrawInsideTrashCan';
import { DrawInsideTray } from './DrawInsideTray';
import type { IDrawCabinetInsideElement } from './IDrawCabinetInsideElement';

export class DrawCabinetInsideGroupElement implements IDrawCabinetInsideElement {
    @Exclude()
    TypeName: string = this.constructor.name;

    Orientation!: EOrientation;

    @Type(() => DrawCabinetInsideElement, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: 'typeName',
            subTypes: [
                { value: DrawInsideBottleShelf, name: 'DrawInsideBottleShelf' },
                { value: DrawInsideDoorRack, name: 'DrawInsideDoorRack' },
                { value: DrawInsideHookBar, name: 'DrawInsideHookBar' },
                { value: DrawInsideLiftingColumn, name: 'DrawInsideLiftingColumn' },
                { value: DrawInsidePlateHolder, name: 'DrawInsidePlateHolder' },
                { value: DrawInsideShelf, name: 'DrawInsideShelf' },
                { value: DrawInsideShelfSystem, name: 'DrawInsideShelfSystem' },
                { value: DrawInsideTablet, name: 'DrawInsideTablet' },
                { value: DrawInsideTrashCan, name: 'DrawInsideTrashCan' },
                { value: DrawInsideTray, name: 'DrawInsideTray' },
                // Ajoutez d'autres sous-classes ici
            ],
        },
    })
    SubElements!: IDrawCabinetInsideElement[];

    @Expose()
    toFlatHierarchy(): IDrawCabinetInsideElement[] {
        return this.SubElements.flatMap(element => element.toFlatHierarchy());
    }
}
